(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["description-readmore"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('description-readmore')) {
    customElements.define('description-readmore', class DescriptionReadmore extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector('[ref="content"]');
        this.toggle = this.querySelector('[ref="toggle"]');
        this.expanded = false;

        if (this.toggle) {
          this.toggle.addEventListener('click', () => this.onToggle());
        }

        // Hide toggle if content is short enough
        requestAnimationFrame(() => {
          if (this.content && this.content.scrollHeight <= this.content.offsetHeight + 2) {
            this.toggle.style.display = 'none';
            this.querySelector('[ref="fade"]').style.display = 'none';
          }
        });
      }

      onToggle() {
        this.expanded = !this.expanded;
        this.content.classList.toggle('is-expanded', this.expanded);
        this.toggle.textContent = this.expanded ? this.toggle.dataset.less : this.toggle.dataset.more;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["initials-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('initials-picker')) {
    customElements.define('initials-picker', class InitialsPicker extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.initials-picker__input');
        this.count = this.querySelector('.initials-picker__count');

        if (this.input) {
          this.input.addEventListener('input', this.onInput.bind(this));

        }
      }

      onInput() {
        // Only allow letters and numbers
        this.input.value = this.input.value.replace(/[^A-Za-z0-9]/g, '').substring(0, 4).toUpperCase();
        this.count.textContent = this.input.value.length + ' / 4';
      }


    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lining-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lining-picker')) {
    customElements.define('lining-picker', class LiningPicker extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.options = this.querySelectorAll('.lining-picker__swatch');
        this.nameEl = this.querySelector('[ref="selectedName"]');
        this.surchargeEl = this.querySelector('[ref="surchargeText"]');
        this.property = this.querySelector('[data-lining-property]');
        this.upgrade = this.querySelector('[data-lining-upgrade]');
        this.options.forEach(option => option.addEventListener('click', () => this.select(option)));
        const selected = this.querySelector('.is-selected');
        if (selected) this.select(selected);
      }
      select(option) {
        this.options.forEach(o => {
          const selected = o === option;
          o.classList.toggle('is-selected', selected);
          o.setAttribute('aria-pressed', String(selected));
        });
        this.nameEl.textContent = option.dataset.name;
        this.surchargeEl.textContent = option.dataset.surcharge;
        this.property.value = option.dataset.name;
        this.upgrade.value = option.dataset.upgradeVariant;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-faq"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-faq')) {
    customElements.define('product-faq', class ProductFaq extends HTMLElement {
      constructor() {
        super();
        this.toggle = this.querySelector('[ref="toggle"]');
        this.panel = this.querySelector('[ref="panel"]');
        this.open = false;

        if (this.toggle) {
          this.toggle.addEventListener('click', () => this.onToggle());
        }
      }

      onToggle() {
        this.open = !this.open;
        this.panel.hidden = !this.open;
        this.panel.classList.toggle('is-open', this.open);
        this.toggle.setAttribute('aria-expanded', String(this.open));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shipping-returns"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shipping-returns')) {
    customElements.define('shipping-returns', class ShippingReturns extends HTMLElement {
      constructor() {
        super();
        this.toggle = this.querySelector('[ref="toggle"]');
        this.panel = this.querySelector('[ref="panel"]');
        this.open = false;

        if (this.toggle) {
          this.toggle.addEventListener('click', () => this.onToggle());
        }
      }

      onToggle() {
        this.open = !this.open;
        this.panel.hidden = !this.open;
        this.panel.classList.toggle('is-open', this.open);
        this.toggle.setAttribute('aria-expanded', String(this.open));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
